import { ModelType } from '@/types';

interface TutorialStep {
  title: string;
  description: string;
  images: string[];
}

export const tutorials: Record<ModelType, TutorialStep[]> = {
  Person: [
    {
      title: 'Input model name and type',
      description:
        'Name your model any name you want, and select the type of subject (Person)',
      images: [
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-output-example1.png',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-output-example2.png',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-output-example3.png',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-output-example.jpg',
      ],
    },
    {
      title: 'Choose good pictures',
      description:
        '10-20 high-quality samples, front facing, square aspect ratio, 1 person in frame, variety of poses and backgrounds',
      images: [
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example5.jpg',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example3.jpg',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example2.jpg',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example4.jpg',
      ],
    },
    {
      title: 'Example of bad pictures',
      description:
        'Transparent background, blurry, side profile, group photos, or images with text overlays',
      images: [
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example2.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
      ],
    },
  ],
  Product: [
    {
      title: 'Input model name and type',
      description:
        'Name your model any name you want, and select the type of subject (Product)',
      images: [
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-output-example2.png',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-output-example1.png',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-output-example5.png',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-output-example4.png',
      ],
    },
    {
      title: 'Choose good pictures',
      description:
        '5-10 high-quality samples, different angles, square aspect ratio, 1 product in frame, variety of backgrounds',
      images: [
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-input-example2.png',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-input-example1.png',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-input-example5.png',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Product/product-input-example7.png',
      ],
    },
    {
      title: 'Example of bad pictures',
      description:
        'Transparent background, multiple products, busy backgrounds, or images with text overlays',
      images: [
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
      ],
    },
  ],
  Style: [
    {
      title: 'Input model name and type',
      description:
        'Name your model any name you want, and select the type of subject (Style)',
      images: [
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Style/product-output-example1.jpeg',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Style/product-output-example2.jpeg',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Style/product-output-example3.jpeg',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Style/product-output-example4.jpeg',
      ],
    },
    {
      title: 'Choose good pictures',
      description:
        '5-10 high-quality samples, front facing, square aspect ratio, 1 style in frame, variety',
      images: [
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
      ],
    },
    {
      title: 'Example of bad pictures',
      description: 'Transparent background, mixed styles, low resolution, or images with watermarks',
      images: [
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
    //  'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
      ],
    },
  ],
  Fashion: [
    {
      title: 'Input model name and type',
      description:
        'Name your model any name you want, and select the type of subject (Product). Describe it ie. hat, jacket, hoodie, coat, boots, etc. Train on one SKU and one colorway.',
      images: [
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-output-example1.jpeg',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-output-example2.jpeg',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-output-example3.jpeg',
      ],
    },
    {
      title: 'Choose good pictures',
      description:
        'Upload at least 5 high-quality images (15+ is ideal) with the product facing forward, logo and details clearly visible. Avoid side/back views. Product should be the only item in frame, shown consistently in same color/size. Photos can be iPhone quality in real-world settings.',
      images: [
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-input-example1.jpeg',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-input-example2.jpeg',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-input-example3.jpeg',
        'https://prompz-bucket.s3.us-east-1.amazonaws.com/Tutorial/Fashion/fashion-input-example4.jpeg',
      ],
    },
    {
      title: 'Example of bad pictures',
      description:
        'Transparent background, side views, back views, overhead angles, product leaning back, multiple items in frame, inconsistent colors/sizes, product too far/close',
      images: [
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
        // 'https://prompz-bucket.s3.us-east-1.amazonaws.com/person-c/person-input-example1.jpeg',
      ],
    },
  ],
};
